import { render } from "./imageTagComp.vue?vue&type=template&id=82ec13f6&scoped=true"
import script from "./imageTagComp.vue?vue&type=script&lang=js"
export * from "./imageTagComp.vue?vue&type=script&lang=js"

import "./imageTagComp.vue?vue&type=style&index=0&id=82ec13f6&scoped=true&lang=css"

import exportComponent from "F:\\Programming_And_Stuff\\Programming\\Stella-Maris-53-VueJSOld\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-82ec13f6"]])

export default __exports__